/**
 * Employee Web — `/me/travel/$id` detail route.
 *
 * Phase 19 Plan 02. Read-only travel-request detail view via
 * `useMeTravelRequest`. Cancel CTA visible when status === "PENDING" and
 * caller has `travel:request:self`. Permission gate (loader): `travel:read:self`.
 * UUID shape guarded so non-UUID URLs 404 deterministically.
 */
import type { JSX } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeTravelDetail } from "../features/travel/MeTravelDetail";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const permissionGate = requirePermission({
  anyOf: ["travel:read:self"],
  defaultRoute: "/me/overview",
});

export const Route = createFileRoute("/_auth/me/travel/$id")({
  staticData: { breadcrumb: { labelKey: "expenses:me.travel.page.title" } },
  beforeLoad: (args) => {
    if (!UUID_REGEX.test(args.params.id)) {
      throw notFound();
    }
    permissionGate(args);
  },
  component: MeTravelDetailRoute,
});

function MeTravelDetailRoute(): JSX.Element {
  const { id } = Route.useParams();
  return <MeTravelDetail travelRequestId={id} />;
}
